import type { StateCreator } from 'zustand';

export function createSetter<TState>(
  set: (partial: Partial<TState> | ((state: TState) => Partial<TState>)) => void
) {
  return function <K extends keyof TState>(key: K) {
    return function (value: TState[K] | ((prev: TState[K]) => TState[K])) {
      if (typeof value === 'function') {
        set((state) => ({ [key]: (value as Function)(state[key]) } as unknown as Partial<TState>));
      } else {
        set({ [key]: value } as unknown as Partial<TState>);
      }
    };
  };
}
